<div fxLayout="row" class="main-wrapper" *ngIf="items.length > 0">
    <form [formGroup]="dropdownForm" fxFlexFill fxFlex.gt-sm="100" fxFlex.xs="100">
      <mat-label class="mat-form-field-label-dropdown"> {{ "load-chainage-dropdown-title" | translate: {required: this.required ? '*' : ''} }} </mat-label>
      <ng-multiselect-dropdown
    appFocusOnClick
    [placeholder]=placeholder
    [settings]="dropdownSettings"
    [data]="items"
    (onSelect)="onSelect($event)"
    (onSelectAll)="onSelectAll($event)"
    (onDeSelect)="onItemDeSelect($event)"
    name="selected"
    [(ngModel)]="selectedItems"
    formControlName="selected"
  >
  </ng-multiselect-dropdown>
  <mat-error class="dropdown-error" *ngIf="dropdownForm.touched && !singleSelection && dropdownForm.controls['selected'].errors?.['required']">
    {{ "error.required_categories" | translate }}
  </mat-error>
  <mat-error class="dropdown-error" *ngIf="dropdownForm.touched && singleSelection && dropdownForm.controls['selected'].errors?.['required']">
    {{ "error.required_category" | translate }}
  </mat-error>
  </form>
  </div>
